import $ from 'jquery'

$(document).ready(function() {

  const navbar = $(`.js-navbar`)

  if (navbar.length) {
    const navbarHidden = sessionStorage.getItem('navbar-hidden')
    if (navbarHidden) {
      navbar.hide(200)
    } else {
      const navbarClose = navbar.find(`.js-navbar-close`)
      navbarClose.on('click', (e) => {
        navbar.hide(200)
        sessionStorage.setItem('navbar-hidden', 'true')
      })
    }
  }
})
